import 'bootstrap/dist/css/bootstrap.min.css';
import React, {useState} from "react";
import {Container} from "react-bootstrap";
import "./stylesheet.css";

import DataExtract from "./components/DataExtract";
import ForestPlotCard from "./components/ForestPlotCard";
import PreviewForestPanel from "./components/PreviewForestPanel";
import StudyUploader from "./components/StudyUploader";


function App() {
  const [studies, setStudies] = useState([]);
  const [outcome, setOutcome] = useState('');
  const [intervention, setIntervention] = useState('');
  const [comparison, setComparison] = useState('');

  const [model, setModel] = useState('GPT-4');
  const [robType, setRobType] = useState('ROB1');

  const [parsedData, setParsedData] = useState([]);
  const [outcomeType, setOutcomeType] = useState(null); // 'binary' or 'continuous'
  const [plotUrl, setPlotUrl] = useState(null);

  const [riskOfBiasMap, setRiskOfBiasMap] = useState([]); // NEW


  async function requestForestPlot(parsedData, outcomeType, metric, effect_model, level) {
    if (!parsedData || parsedData.length === 0) {
      console.error("No parsed data to send.");
      return;
    }

    // Extract data matrix
    let studies = [];
    let labels = [];
    let RoBMap = [];

    for (const entry of parsedData) {
      labels.push(entry.name);
      if (outcomeType === "binary") {
        studies.push([
          Number(entry.intervention_events),
          Number(entry.intervention_total),
          Number(entry.comparator_events),
          Number(entry.comparator_total),
        ]);
      } else if (outcomeType === "continuous") {
        studies.push([
          Number(entry.intervention_mean),
          Number(entry.intervention_sd),
          Number(entry.intervention_group_size),
          Number(entry.comparator_mean),
          Number(entry.comparator_sd),
          Number(entry.comparator_group_size),
        ]);
      }
    }

    for(const robEntry of riskOfBiasMap){
        RoBMap.push(robEntry.values);
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/generate_forestplot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          studies,
          labels,
          metric,
          effect_model,
          level: parseInt(level.replace("%", "")),
          method: "REML",
          format: "png",
          risk_of_bias_map: RoBMap,
          risk_of_bias_tool: robType,
        }),
      });

      if (!res.ok) {
        const error = await res.json();
        console.error("Server error:", error);
        return;
      }

      // Get image blob
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      // You can use this to display or download the image
      // const link = document.createElement("a");
      // link.href = url;
      // link.download = "forest_plot.png";
      // link.click();
      setPlotUrl(url);

    } catch (err) {
      console.error("Failed to generate forest plot:", err);
    }
  }


  return (
    <div className="App">
      <Container className="py-5">
        <h1 className="text-center fw-bold mb-4">
          <img
            src="/favicon.png"
            alt="Logo"
            style={{ width: '80px', height: '80px', marginRight: '10px', verticalAlign: 'middle' }}
          />
          AutoForest
        </h1>

        <p className="text-center text-muted mb-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
          Upload studies consisting of one or more biomedical papers (PDFs), specify an outcome and a comparison, and automatically generate a forest plot!
        </p>

        <StudyUploader studies={studies} setStudies={setStudies} />

        <DataExtract
          studies={studies}
          model={model}
          setModel={setModel}
          intervention={intervention}
          setIntervention={setIntervention}
          comparison={comparison}
          setComparison={setComparison}
          outcome={outcome}
          robType={robType}
          setRobType={setRobType}
          setOutcome={setOutcome}
          setParsedData={setParsedData}
          setOutcomeType={setOutcomeType}
          riskOfBiasMap={riskOfBiasMap}
          setRiskOfBiasMap={setRiskOfBiasMap}
        />

        {parsedData.length > 0 && outcomeType && (
          <PreviewForestPanel
            parsedData={parsedData}
            setParsedData={setParsedData}
            outcomeType={outcomeType}
            intervention={intervention}
            comparison={comparison}
            robType={robType}
            riskOfBiasMap={riskOfBiasMap}
            setRiskOfBiasMap={setRiskOfBiasMap}
            requestForestPlot={requestForestPlot}
          />
        )}

        {plotUrl && <ForestPlotCard plotUrl={plotUrl} />}

      </Container>
    </div>
  );
}


export default App;
